/**
 * Singleton API client for Checkout module
 *
 * Centralizes all API calls with proper typing.
 * Uses Infrastructure's request helper.
 */

import { request } from '../../../Infrastructure'
import { createGuestCartMutation, addToCartMutation } from '../queries'

import type { CreateEmptyCartData, AddToCartData, CartItemInput } from '../types'

/**
 * Checkout API client
 *
 * Note: request<T>() returns Promise<{ data: T }>, so we unwrap to return T directly
 */
export const checkoutApi = {
  /**
   * Create a guest cart
   */
  createGuestCart: async (): Promise<CreateEmptyCartData> => {
    const response = await request<CreateEmptyCartData>(createGuestCartMutation)
    return response.data
  },

  /**
   * Add products to cart
   */
  addToCart: async (cartId: string, cartItems: CartItemInput[]): Promise<AddToCartData> => {
    const response = await request<AddToCartData>(addToCartMutation, { cartId, cartItems })
    return response.data
  },
}
